import { SxProps, Theme } from '@mui/material';

export const chipDeleteIconStyles: SxProps<Theme> = [
	{
		'.MuiChip-deleteIcon': {
			fontSize: '12px',
			color: 'white',
			'&:hover': {
				color: 'white',
			},
		},
	},
];

export const chipFilterStyles: SxProps<Theme> = [
	{
		'.MuiChip-deleteIcon': {
			fontSize: '12px',
			color: (theme) => theme.colors.lightBlue,
			borderWidth: 0,
			mr: '6px',
			ml: 0,
			'&:hover': {
				color: (theme) => theme.colors.lightBlue,
			},
		},
		color: (theme) => theme.colors.lightBlue,
		borderColor: (theme) => theme.colors.lightBlue,
		'.MuiChip-label': {
			px: '6px',
		},
		fontSize: '12px',
		height: '20px'
	},
];
